

import { useState } from "react"
import { useAuth } from "../contexts/AuthContext"
import { Container, Paper, Box, Typography, TextField, Button, Alert, Tab, Tabs, CircularProgress } from "@mui/material"
import { useForm } from "react-hook-form"

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`auth-tabpanel-${index}`}
      aria-labelledby={`auth-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  )
}

function LoginPage() {
  const [tabValue, setTabValue] = useState(0)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState({ type: "", text: "" })
  const { login, register } = useAuth()

  const loginForm = useForm()
  const registerForm = useForm()

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
    setMessage({ type: "", text: "" })
  }

  const onLoginSubmit = async (data) => {
    setLoading(true)
    setMessage({ type: "", text: "" })

    const result = await login(data)

    if (!result.success) {
      setMessage({ type: "error", text: result.error })
    }
    setLoading(false)
  }

  const onRegisterSubmit = async (data) => {
    setLoading(true)
    setMessage({ type: "", text: "" })

    if (data.password !== data.confirmPassword) {
      setMessage({ type: "error", text: "Passwords do not match" })
      setLoading(false)
      return
    }

    const { confirmPassword, ...registerData } = data
    const result = await register(registerData)

    if (result.success) {
      setMessage({ type: "success", text: result.message })
      registerForm.reset()
    } else {
      setMessage({ type: "error", text: result.error })
    }
    setLoading(false)
  }

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Paper elevation={3} sx={{ width: "100%", mt: 3 }}>
          <Box sx={{ display: "flex", justifyContent: "center", pt: 2 }}>
            <Typography component="h1" variant="h4" color="primary" fontWeight="bold">
              Fiscale
            </Typography>
          </Box>

          {/* <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={tabValue} onChange={handleTabChange} centered>
              <Tab label="Login" />
              <Tab label="Sign Up" />
            </Tabs>
          </Box> */}

          {message.text && (
            <Box sx={{ p: 2 }}>
              <Alert severity={message.type}>{message.text}</Alert>
            </Box>
          )}

          {/* <TabPanel value={tabValue} index={0}> */}
            <Box component="form" onSubmit={loginForm.handleSubmit(onLoginSubmit)} sx={{padding:3}}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="phoneNumber"
                label="Phone Number"
                name="phoneNumber"
                // autoComplete="email"
                autoFocus
                {...loginForm.register("phoneNumber", {
                  required: "Phone number is required",
                  pattern: {
                    value: /^\d{10}$/,
                    message: "Invalid phone number",
                  },
                })}
                error={!!loginForm.formState.errors.phoneNumber}
                helperText={loginForm.formState.errors.phoneNumber?.message}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                {...loginForm.register("password", {
                  required: "Password is required",
                })}
                error={!!loginForm.formState.errors.password}
                helperText={loginForm.formState.errors.password?.message}
              />
              <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }} disabled={loading}>
                {loading ? <CircularProgress size={24} /> : "Sign In"}
              </Button>
            </Box>
          {/* </TabPanel> */}

          {/* <TabPanel value={tabValue} index={1}>
            <Box component="form" onSubmit={registerForm.handleSubmit(onRegisterSubmit)}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="name"
                label="Full Name"
                name="name"
                autoComplete="name"
                {...registerForm.register("name", {
                  required: "Name is required",
                })}
                error={!!registerForm.formState.errors.name}
                helperText={registerForm.formState.errors.name?.message}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                {...registerForm.register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^\S+@\S+$/i,
                    message: "Invalid email address",
                  },
                })}
                error={!!registerForm.formState.errors.email}
                helperText={registerForm.formState.errors.email?.message}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="new-password"
                {...registerForm.register("password", {
                  required: "Password is required",
                  minLength: {
                    value: 6,
                    message: "Password must be at least 6 characters",
                  },
                })}
                error={!!registerForm.formState.errors.password}
                helperText={registerForm.formState.errors.password?.message}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="confirmPassword"
                label="Confirm Password"
                type="password"
                id="confirmPassword"
                autoComplete="new-password"
                {...registerForm.register("confirmPassword", {
                  required: "Please confirm your password",
                })}
                error={!!registerForm.formState.errors.confirmPassword}
                helperText={registerForm.formState.errors.confirmPassword?.message}
              />
              <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }} disabled={loading}>
                {loading ? <CircularProgress size={24} /> : "Sign Up"}
              </Button>
              <Typography variant="body2" color="text.secondary" align="center">
                Note: Registration is only available for admin users
              </Typography>
            </Box>
          </TabPanel> */}
        </Paper>
      </Box>
    </Container>
  )
}

export default LoginPage
